import React                  from 'react'
import Box                    from '@material-ui/core/Box'
import Container              from '@material-ui/core/Container'
import FormControlLabel       from '@material-ui/core/FormControlLabel'
import Grid                   from '@material-ui/core/Grid'
import PropTypes              from 'prop-types'
import Radio                  from '@material-ui/core/Radio'
import RadioGroup             from '@material-ui/core/RadioGroup'

const RadioOptionComponent = ({getOption, options}) => {

   const DisplayOptions = options.map( (o, i) => {
      return(
         <FormControlLabel
            control={<Radio color='primary' />}
            data-testid={o}
            key={i}
            label={o}
            labelPlacement='top'
            onClick={() => handleClick(o)}
            value={o}
         />
      )
   } )

   const handleClick = (o) => {
      getOption(o)
   }
console.log('options are', options)
   return (
      <Box>
         <Container>
            <Grid container justifyContent='center' style={{marginTop: '2rem'}}>
               <RadioGroup row>
                  { DisplayOptions }
               </RadioGroup>
            </Grid>
         </Container>
      </Box>
   )
}

RadioOptionComponent.propTypes = {
  getOption:   PropTypes.func,
  options:     PropTypes.array
}

export default RadioOptionComponent
